import axios from "axios";
import { useState } from "react";
import { getAnalyticsBaseUrl } from "utils/helpers";

export function UseLazyApiCallInternalDashboard({ url, method, body }) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  const baseUrl = `${getAnalyticsBaseUrl()}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "bearer bde14d5ef15ef9f2189e1db876c004907ac857f85976f95d1e3effd350bf60e9",
  };

  async function getData(props) {
    const localData = props?.params || body;

    try {
      setIsLoading(true);
      const requestConfig = {
        method,
        url: `${baseUrl}/${url}`,
        headers,
        data: JSON.stringify(localData),
        timeout: 100000,
      };
      const response = await axios.request(requestConfig);

      setData(response?.data);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }

  function refetch() {
    getData();
  }

  return [getData, { data, isLoading, error, refetch }];
}
